import { Intent } from '@blueprintjs/core';

import { colors } from '../../../styles/variables';

export enum StatusType {
  Active = 'Active',
  Complete = 'Complete',
  Inactive = 'Inactive',
  Incomplete = 'Incomplete',
}

export type StatusIntent = Intent | 'secondary';

export const IntentColors: Record<StatusIntent, string> = {
  [Intent.PRIMARY]: colors.clearChill,
  secondary: colors.tempGreen2,
  [Intent.WARNING]: colors.themeOrange,
  [Intent.DANGER]: colors.themeRed,
  [Intent.SUCCESS]: colors.kellyGreen,
  [Intent.NONE]: colors.cistern,
};

export const ImportantIntentColors: Record<StatusIntent, string> = {
  ...IntentColors,
  [Intent.PRIMARY]: colors.celticBlue,
  [Intent.WARNING]: colors.themeOrange,
  [Intent.DANGER]: colors.themeRed,
};

export const StatusToIntent: Record<string, Intent> = {
  0: Intent.NONE,
  1: Intent.SUCCESS,
  active: Intent.SUCCESS,
  approved: Intent.SUCCESS,
  backlog: Intent.PRIMARY,
  complete: Intent.SUCCESS,
  completed: Intent.SUCCESS,
  draft: Intent.NONE,
  ended: Intent.DANGER,
  failed: Intent.DANGER,
  false: Intent.NONE,
  'identified violation': Intent.DANGER,
  ignored: Intent.NONE,
  inactive: Intent.NONE,
  live: Intent.SUCCESS,
  overdue: Intent.DANGER,
  paid: Intent.SUCCESS,
  'pending compliance review': Intent.WARNING,
  rejected: Intent.DANGER,
  'requires lender approval': Intent.WARNING,
  scheduled: Intent.PRIMARY,
  started: Intent.PRIMARY,
  true: Intent.SUCCESS,
  undefined: Intent.NONE,
  unpaid: Intent.NONE,
  upcoming: Intent.PRIMARY,
  'waiting on supply partner': Intent.PRIMARY,
};
